import React, { useEffect } from 'react';
import ModalBackdrop from './Components/Modal/ModalBackdrop.tsx';
import ModalContent from './Components/Modal/ModalContent.tsx';
import PortalContainer from './Components/FitAssistantButton/PortalContainer.tsx';
import StepRouter from './StepRouter.tsx';
import { useAppState } from './BikesAppState.tsx';
import { BikeAdapterProduct, BikeAdaptersResponse } from './Types/Types.ts';

const FitAssistantBikes = () => {
  const { showFitAssistant, setShowFitAssistant, setProducts } = useAppState();

  const html: HTMLElement | null = document.querySelector('html');
  const body: HTMLElement | null = document.querySelector('body');
  const thuleWidget: HTMLElement | null = document.querySelector('div[data-thule-widget]');

  const params = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (params.has('openFa')) setShowFitAssistant(true);
  }, []);

  useEffect(() => {
    if (showFitAssistant) {
      html?.classList.add('overflow-hidden');
      body?.classList.add('overflow-hidden');
      if (thuleWidget) thuleWidget.style.display = 'none';
    } else {
      html?.classList.remove('overflow-hidden');
      body?.classList.remove('overflow-hidden');
      if (thuleWidget) thuleWidget.style.display = 'inline';
    }
  }, [showFitAssistant]);

  useEffect(() => {
    let ignore = false;
    const controller = new AbortController();

    const toProducts = (data: unknown): BikeAdapterProduct[] => {
      if (!data || typeof data !== 'object') {
        return [];
      }
      const response = data as Partial<BikeAdaptersResponse>;
      return Array.isArray(response.Products) ? response.Products : [];
    };

    async function fetchData() {
      try {
        const res = await fetch('/api/sitecore/fitguide/bikeadapters', { signal: controller.signal });
        const data: unknown = await res.json();
        if (!ignore) {
          setProducts(toProducts(data));
        }
      } catch (err) {
        // AbortError is expected during unmount; other errors should be logged.
        if (!ignore) {
          console.error('FitAssistantBikes /api/getdata failed:', err);
        }
      }
    }

    fetchData();

    return () => {
      ignore = true;
      controller.abort();
    };
  }, [setProducts]);

  return (
    <>
      <PortalContainer />
      <ModalContent>
        <StepRouter />
      </ModalContent>
      <ModalBackdrop />
    </>
  );
};

export default FitAssistantBikes;
